import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { contentService } from "services/content.service";
import { Path } from "constants/constant";

const LINKS: { label: string; path: string; emoji: string }[] = [
  { label: "Birds", path: Path.BIRDS, emoji: "🐦" },
  { label: "Butterflies", path: Path.BUTTERFLY, emoji: "🦋" },
  { label: "Fauna", path: Path.FAUNA, emoji: "🦦" },
];

export const SpeciesCounter = () => {
  const [stats, setStats] = useState<Record<string, number> | null>(null);

  useEffect(() => {
    contentService
      .getStats()
      .then((s) =>
        setStats({
          birds: s.birds,
          butterflies: s.butterflies,
          fauna: s.fauna,
        }),
      )
      .catch(() => setStats(null));
  }, []);

  if (!stats) return null;

  return (
    <div
      style={{
        display: "flex",
        gap: "2rem",
        justifyContent: "center",
        flexWrap: "wrap",
        marginTop: "1.5rem",
      }}
    >
      {LINKS.map(({ label, path, emoji }) => (
        <Link key={label} to={path} style={{ textDecoration: "none" }}>
          <Stat
            label={label}
            count={stats[label.toLowerCase()] ?? 0}
            emoji={emoji}
          />
        </Link>
      ))}
    </div>
  );
};

const Stat = ({
  label,
  count,
  emoji,
}: {
  label: string;
  count: number;
  emoji: string;
}) => (
  <div style={{ textAlign: "center" }}>
    <div style={{ fontSize: "1.5rem", fontWeight: 700, color: "#556b2f" }}>
      {emoji} {count.toLocaleString()}
    </div>
    <small style={{ color: "#a7a7a7" }}>{label}</small>
  </div>
);
